import { render, staticRenderFns } from "./EarnedBadgeModal.vue?vue&type=template&id=fb6120f6"
import script from "./EarnedBadgeModal.vue?vue&type=script&lang=js"
export * from "./EarnedBadgeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports